import { Component, DestroyRef, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { SelectRoadService } from './services/select-road.service';
import { Road } from './models/select-road.model';
import { StateService } from '../../core/services/state.service';
import { UtilsService } from '../../core/services/utils.service';
import { Status } from '../../shared/constants/response-results';

@Component({
  selector: 'app-select-road',
  standalone: true,
  imports: [DropdownModule, ButtonModule, CardModule, FormsModule, CommonModule],
  templateUrl: './select-road.component.html',
  styleUrl: './select-road.component.scss',
})
export class SelectRoadComponent {
  roads: Road[] | undefined = undefined;
  selectedRoad: Road | null = null;
  hasError: boolean = false;
  hasAuthorizationError: boolean = false;
  errorMessage: string =
    'Ha ocurrido un error al cargar las carreteras. Por favor, inténtelo de nuevo más tarde.';
  errorAuthorizationMessage: string = 'No dispone de los permisos necesarios para acceder a esta aplicación';
  ref: DynamicDialogRef | undefined;

  private destroyRef = inject(DestroyRef);

  constructor(
    private selectRoadService: SelectRoadService,
    private stateService: StateService,
    private route: Router,
    private utilsService: UtilsService,
  ) {
    this.stateService.availableRoads$
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((roads) => {


      if ((roads.length==0) && (this.roads==undefined)) {
        this.loadRoads();
        return;
      }
    
      this.roads = roads;
      this.hasError = false;
    });
  }

  loadRoads() {
    this.hasError = false;
    this.selectRoadService.getRoads()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe({
      next: (res) => {
        this.roads = res;
        this.stateService.setAvailableRoads(this.roads);
      },
      error: (error) => {
        console.error('Error al cargar las carreteras:', error);
        this.hasError = true;
        this.roads = undefined;
        if(error.status == 403) this.hasAuthorizationError = true;
        this.ref = this.utilsService.showResponseResult(
          'Ha ocurrido un error al cargar las carreteras',
          Status.ERROR,
        );
      },
    });
  }

  accessRoad() {
    if (this.selectedRoad) {
      this.stateService.setSelectedRoad(this.selectedRoad);
      this.route.navigate(['/center-activity']);
    }
  }

  retryLoad() {
    this.loadRoads();
  }
}
